module.exports = __webpack_public_path__ + "img/GALLERY-SWIFT-SPORT-4.5c62bdea.jpg";